/**
 * @module Utilities/Request
 * @desc Request helper funtions
 */

/* eslint-disable quote-props */
import is from 'is-lite';

import type { Utilities } from 'core/domains';

/**
 * Parse error object
 */
export function parseErrorObject(data: Utilities.PlainObject) {
  const output = {
    message: '',
    detail: '',
  };

  if (!is.plainObject(data)) {
    return output;
  }

  try {
    if (Array.isArray(data.errors)) {
      const { detail, message } = data.errors[0];

      output.message = message;
      output.detail = detail;
    } else if (is.plainObject(data.error) && is.string(data.error.message)) {
      output.message = data.error.message;
    } else if (data.error && is.string(data.error_description)) {
      output.message = data.error_description;
    }
  } catch (error) {
    console.error(error); // eslint-disable-line no-console
  }

  return output;
}
